export default __webpack_public_path__ + "static/media/pink.d322abbd.png";